import { ReactNode } from "react"
import SidePanel from "./SidePanel"
import { FilterBlockGroupProvider } from "./FilterBlock"

interface Props {
  children: ReactNode
  width?: number
}

export default function FilterSidePanel({ children, width = 400 }: Props) {
  return (
    <SidePanel width={width} defaultOpen side="right">
      <FilterBlockGroupProvider>
        {/* Le panel filtre ne scrolle pas lui-même (min-h-0 + overflow-hidden) : c'est la carte
            ouverte qui scrolle en interne. Ça évite qu'un débordement d'1px du flex-grow réactive
            le scroll et pousse le pb-4 hors de vue. box-border : padding compté dans le h-full. */}
        <div className="box-border flex h-full min-h-0 flex-col overflow-hidden [&>.list-item]:!flex-none">
          {children}
        </div>
      </FilterBlockGroupProvider>
    </SidePanel>
  )
}
